import { Routes } from '@angular/router';

export const routes: Routes = [
    {
        path: 'voucher-registration',
        pathMatch: 'full',
        loadComponent: () =>
            import('@pages/voucher-registration/voucher-registration.component').then(
                (m) => m.VoucherRegistrationComponent,
            ),
    },
    {
        path: 'beyond-registration',
        pathMatch: 'full',
        loadComponent: () =>
            import('@pages/beyond-registration/beyond-registration.component').then(
                (m) => m.BeyondRegistrationComponent,
            ),
    },
    {
        path: 'education-registration',
        pathMatch: 'full',
        loadComponent: () =>
            import('@pages/beyond-registration/beyond-registration.component').then(
                (m) => m.BeyondRegistrationComponent,
            ),
    },
    {
        path: 'user-registration',
        pathMatch: 'full',
        loadComponent: () =>
            import('@pages/user-registration/user-registration.component').then((m) => m.UserRegistrationComponent),
    },
    {
        path: 'ucp-registration',
        pathMatch: 'full',
        loadComponent: () =>
            import('@pages/ucp-registration/ucp-registration.component').then((m) => m.UcpRegistrationComponent),
    },
    {
        path: '',
        redirectTo: 'education-registration',
        pathMatch: 'full',
    },
    {
        path: '**',
        loadComponent: () => import('@components/not-found/not-found.component').then((m) => m.NotFoundComponent),
    },
];
